import ClockIcon from "../Icon/ClockIcon";
import TicketIcon from "../Icon/TicketIcon";
import styles from "./GameInfo.module.css";
import Statistic from "./Statistic";
import Tag from "./Tag";
import CountDown from "./CountDown";
import GameTag from "../STags/GameTag";
import { StrToCurrency } from "../../api/ApiGame";
import { useTranslation } from "react-i18next";
const GameInfo: React.FC<{
  gameInfo: any;
  size?: "m" | "s";
  rightButton?: React.ReactNode;
  showDetail?: boolean;
  padding?: string;
  margin?: string;
}> = ({
  gameInfo,
  size = "m",
  rightButton,
  showDetail = false,
  padding = "",
  margin = "",
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className={`${styles.wrapper} ${styles[size]}`}
        style={{
          ...(padding ? { padding } : {}),
          ...(margin ? { margin } : {}),
        }}
      >
        <div className={styles.mainWrapper}>
          <div>
            <img src={gameInfo.game.imgUrl} alt="" loading="lazy" decoding="async" width={64} height={64} />
          </div>
          <div className={styles.infoWrapper}>
            <div className={styles.title}>
              {gameInfo?.game?.gameName?.toUpperCase() +
                (gameInfo?.draw?.drawNumber
                  ? " #" + gameInfo.draw.drawNumber
                  : "")}
            </div>
            <div className={styles.description}>
              {gameInfo?.game?.description}
            </div>
          </div>
          {!!rightButton && (
            <div className={styles.rightButton}>{rightButton}</div>
          )}
        </div>
        {showDetail && gameInfo.draw && (
          <div className={styles.statistics}>
            <Statistic
              title={t("games.mainPrice")}
              data={gameInfo.draw.mainPrize ? StrToCurrency(gameInfo.draw.mainPrize) : "A confirmar"}
            />
            <Statistic
              title={t("games.timeLeft")}
              data={
                <CountDown
                  initialSeconds={
                    Number(
                      Math.floor((gameInfo.draw.stopTime - Date.now()) / 1000)
                    ) || 0
                  }
                />
              }
            />
          </div>
        )}
        <div className={styles.tags}>
          {gameInfo.draw && (
            <Tag
              label={gameInfo.draw.drawNumber || ""}
              icon={<TicketIcon color="#35A9FB" />}
            />
          )}
          {gameInfo.draw && gameInfo.draw.isToday && (
            <Tag label={t("games.today")} icon={<ClockIcon color="#FF6505" />} />
          )}
          <GameTag
            tag={gameInfo.game.gameTag || ""}
            name={gameInfo.game.gameName || ""}
          />
        </div>
      </div>
    </>
  );
};

export default GameInfo;
